<script>
  export let pricingTag;
</script>

<div
  class="hero-banner"
  class:border-[--color-accent,#8dc63f]={!pricingTag?.customColor?.active}
  class:text-[--color-accent,#8dc63f]={!pricingTag?.customColor?.active}
  style={pricingTag?.customColor?.active
    ? `border-color:${pricingTag?.customColor?.color}; color:${
        pricingTag?.customColor?.color
      };`
    : ''}
>
  <a href="#form">
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      stroke-width="3"
      stroke-linecap="round"
      stroke-linejoin="round"
      class="lucide lucide-tag"
      ><path
        d="M12.586 2.586A2 2 0 0 0 11.172 2H4a2 2 0 0 0-2 2v7.172a2 2 0 0 0 .586 1.414l8.704 8.704a2.426 2.426 0 0 0 3.42 0l6.58-6.58a2.426 2.426 0 0 0 0-3.42z"
      /><circle cx="7.5" cy="7.5" r=".5" fill="currentColor" /></svg
    >
    {@html pricingTag?.content?.value || ''}
  </a>
</div>

<style>
  .hero-banner {
    width: 100%;
    text-align: inherit;
  }
  .hero-banner a {
    text-decoration: none !important;
    display: inline-flex;
    align-items: center;
    gap: 8px;
    border: 3px solid;
    padding: 10px 20px;
    border-radius: 25px;
    font-size: 16px;
    font-weight: bold;
    text-align: center;
  }
  .hero-banner svg {
    height: 20px;
    width: 20px;
  }
  @media screen and (max-width: 1024px) {
    .hero-banner {
      max-width: 500px;
      margin: 0 auto;
      text-align: center;
    }
  }
  @media screen and (max-width: 500px) {
    .hero-banner a {
      font-size: 11px;
      border: 2px solid;
      padding: 8px 20px;
    }
    .hero-banner svg {
      height: 12px;
      width: 12px;
    }
  }
</style>
